import { DrawerHeader, ModalProps } from '@features/Modal';
import { Tabs } from '@features/Tabs';
import { IServiceTransfersDto } from '@shared/api';
import { FC, ReactElement } from 'react';
import { GeneralTransfer } from '../GeneralTransfer';
import { TextTooltip } from '@shared/UI';
import './PaymentRequestsViewDrawer.scss';

interface PaymentRequestsViewDrawerProps extends ModalProps {
    paymentRequest: IServiceTransfersDto;
}

interface ITabsContent {
    [key: string]: ReactElement;
}

export const PaymentRequestsViewDrawer: FC<PaymentRequestsViewDrawerProps> = ({ paymentRequest }) => {
    const tabsContent: ITabsContent = {
        General: <GeneralTransfer paymentRequest={paymentRequest} />,
    };
    return (
        <div className='payment-requests-view-drawer'>
            <div className='payment-requests-view-drawer__title'>
                <h4>Transfer ID:</h4>
                <TextTooltip text={paymentRequest.id} />
            </div>
            <Tabs
                tabsContent={tabsContent}
                initialTab='General'
            />
        </div>
    );
};
